import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import MainContent from "../components/MainContent";
import Footer from "../components/Footer";
import "./Styles.css";
import ImageSlider from "./ImageSlider";
import Industry from "./Industry";
import OurService from "./OurService";
import ImageCarousel from "./Image";
import NewsletterSection from "./NewsLetter";
import PopupModal from "./PopUpModal";

function Home() {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="overflow-x-hidden">
      <Header />
      <Navbar />
      <ImageCarousel />
      {/* <ImageSlider /> */}
      <MainContent />
      <Industry />
      <OurService />
      <NewsletterSection />
      <Footer />
      {/* <PopupModal /> */}
    </div>
  );
}

export default Home;